export enum Brand {
    ORANGE = 'Orange',
    SOSH = 'Sosh',
}
